new Swiper(".mySwiper", {
  slidesPerView: 1,
  loop: !0,
  spaceBetween: 5,
  autoplay: { delay: 9e3, disableOnInteraction: !1 },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
});
var i,
  coll = document.getElementsByClassName("collapsible");
for (i = 0; i < coll.length; i++)
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var e = this.nextElementSibling;
    "block" === e.style.display
      ? (e.style.display = "none")
      : (e.style.display = "block");
  });
// function myFunction() {
//   var e = document.getElementById("myDIV");
//   "Read More" === e.innerHTML
//     ? (e.innerHTML = "Read Less")
//     : (e.innerHTML = "Read More");
// }
(() => {
  let e = document.querySelectorAll(".counter"),
    t = Array.from(e);
  t.map((e) => {
    let t = e.textContent,
      n = 1,
      l = e.dataset.speed / t;
    function a() {
      (e.textContent = n++), t < n && clearInterval(o);
    }
    let o = setInterval(() => {
      a();
    }, l);
  });
})(),
  $(".read-more").click(function () {
    $(".product__description.rte").toggleClass("ace");
  });

document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".marquee-offer-text div");
  let startPosition = content?.offsetWidth;
  function animateMarquee() {
    if (startPosition <= -content?.offsetWidth / 2) {
      startPosition = content?.offsetWidth;
    }
    content.style.transform = `translateX(${startPosition}px)`;
    startPosition -= 1; // Adjust speed here
    requestAnimationFrame(animateMarquee);
  }
  if (content) animateMarquee();
});

// new PDP design js

// swiper slider
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".paralasss", {
    speed: 600,
    parallax: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1, // Default
    spaceBetween: 0, // Default
    watchSlidesProgress: true, // Important for parallax + breakpoints
    breakpoints: {
      320: {
        // Mobile
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        // Tablet
        slidesPerView: 1,
        spaceBetween: 20,
      },
      1024: {
        // Desktop
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });
});

// accordian

var acc = document.getElementsByClassName("accordion");
var r;

for (r = 0; r < acc.length; r++) {
  acc[r].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// tabs

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;

  // Hide all tabcontent
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove 'active' class from all tablinks
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show current tab and set active
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.classList.add("active");
}


// append class on body

document.addEventListener("DOMContentLoaded", function () {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const class1 = pathSegments[0];
  const class2 = pathSegments[1];
  if (class1 && class2) {
    document.body.classList.add(`url-${class1}`, `url-${class2}`);
  }
});




// Custom code to pass the value of quantity selector to the sticky ATC button form            
function passValue(val) {
  let updatedQuantity = val;
  // console.log("updatedQuantity", updatedQuantity);
  document.querySelector('[data-quantity-input="sticky_cart"]').value = updatedQuantity;
} 
// Custom code to pass the value of quantity selector to the sticky ATC button form ends here



// varient title update 




(function() {
  document.addEventListener('DOMContentLoaded', function() {
    function updateVariantTitle(variantId) {
      if (!variantId || !displayVariantTitle[variantId]) {
        return;
      }
      const newTitle = displayVariantTitle[variantId];
      const metafieldElement = document.querySelector('.custom-metafield');
      if (metafieldElement) {
        metafieldElement.innerHTML = newTitle;
      }
      const richTextHeading = document.querySelector('h2.rich-text__heading');
      if (richTextHeading) {
        richTextHeading.innerHTML = newTitle;
      }
    }
    document.addEventListener('change', function(e) {
      if (e.target.matches('variant-selects select, variant-selects input, input[name="id"], select[name="id"]')) {
        const variantId = e.target.value || document.querySelector('input[name="id"]')?.value;
        
        if (variantId) {
          updateVariantTitle(variantId);
        }
      }
    });
    document.addEventListener('variant:change', function(e) {
      const variantId = e.detail?.variant?.id || e.detail?.id;
      if (variantId) {
        updateVariantTitle(variantId);
      }
    });
  });
})();

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    async function updateSectionFromVariant() {
      // Get variantId from modal DOM
      const modalContent = document.querySelector('.quick-add-modal__content-info');
      const variantSpan = modalContent?.querySelector('span.option-value-name[data-product-varinat]');
      const variantId = variantSpan?.getAttribute('data-product-varinat');

      if (!variantId) {
        console.warn('Variant ID not found.');
        return;
      }

      // Get all product-info sections on the page
      const productInfoSections = document.querySelectorAll('.my-product-page product-info[data-section]');

      if (productInfoSections.length === 0) {
        console.warn('No product-info sections found.');
        return;
      }

      console.log('Updating sections for variant:', variantId);

      for (const productInfoEl of productInfoSections) {
        const sectionId = productInfoEl.getAttribute('data-section');
        if (!sectionId) {
          console.warn('Section ID missing on a product-info element.');
          continue;
        }

        try {
          // Fetch the updated section HTML
          const response = await fetch(window.location.pathname + `?section_id=${sectionId}&variant=${variantId}`);
          if (!response.ok) throw new Error('Network response was not ok');

          const htmlText = await response.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = htmlText;

          // Find the updated product-info section in the response
          const newContent = tempDiv.querySelector(`.my-product-page product-info[data-section="${sectionId}"]`);

          if (newContent) {
            productInfoEl.replaceWith(newContent);
            console.log(`Section ${sectionId} updated.`);
          } else {
            console.warn(`Updated section ${sectionId} not found in response.`);
          }
        } catch (error) {
          console.error(`Error updating section ${sectionId}:`, error);
        }
      }
    }

    // Listen for variant changes
    document.addEventListener('change', function (e) {
      if (e.target.matches('variant-selects select, variant-selects input, input[name="id"], select[name="id"]')) {
        updateSectionFromVariant();
      }
    });

    document.addEventListener('variant:change', function () {
      updateSectionFromVariant();
    });

    // MutationObserver to detect when .my-product-page product-info sections are added dynamically
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          for (const node of addedNodes) {
            if (node.matches && node.matches('.my-product-page product-info[data-section]')) {
              console.log('Detected new product-info section added to DOM');
              updateSectionFromVariant();
            }
          }
        }
      }
    });

    // Start observing the whole document body for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();





// custom code for quantity 
document.addEventListener('DOMContentLoaded', function() {
  let previousValue = 1;

  function syncInputs(value, container = document) {
    container.querySelectorAll('input#quantity__input[type=hidden][name="quantity"]').forEach(function(input) {
      input.value = value;
      input.setAttribute('value', value);
    });
  }

  function renderQuantitySyncFunctionality(container = document) {
    const visibleInputs = container.querySelectorAll('product-info input.quantity__input[type=number]');
    if (!visibleInputs || visibleInputs.length === 0) {
      console.log("No visible inputs found");
      return;
    }

    visibleInputs.forEach(visibleInput => {
      // Sync initially
      const value = parseInt(visibleInput.value) || 1;
      syncInputs(value, container);
      previousValue = value;

      // Attach listener only once
      if (!visibleInput._hasChangeListener) {
        visibleInput.addEventListener('change', function() {
          const val = parseInt(this.value) || 1;
          syncInputs(val, container);
          previousValue = val;
        });
        visibleInput._hasChangeListener = true;
      }

      // Variant change listener: attach if not attached yet
      let variantSelect = container.querySelector('variant-selects');
      if (variantSelect && !variantSelect._hasChangeListener) {
        variantSelect.addEventListener('change', function() {
          visibleInput.value = 1;
          visibleInput.dispatchEvent(new Event('change'));
        });
        variantSelect._hasChangeListener = true;
      }
    });
  }

  function resetQuantityToOne() {
    const visibleInput = document.querySelector('product-info input.quantity__input[type=number]');
    if (!visibleInput) return;
    visibleInput.value = 1;
    visibleInput.dispatchEvent(new Event('change'));
    syncInputs(1);
    previousValue = 1;
  }

  // Delegate submit event on document for dynamic forms
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.tagName.toLowerCase() === 'form') {
      resetQuantityToOne();
    }
  });

  // Initial render
  renderQuantitySyncFunctionality();

  // Quick-add modal handling - FIXED
  document.addEventListener('click', function(event) {
    if (event.target.closest('.quick-add__submit')) {
      console.log("Quick-add button clicked");
      setTimeout(() => {
        console.log("Re-initializing after modal");
        renderQuantitySyncFunctionality();
      }, 1500); // Reduced timeout to 500ms
    }
  });

  // Re-initialize on Shopify section reloads
  document.addEventListener('shopify:section:load', function() {
    console.log("Section reloaded, re-initializing");
    setTimeout(() => {
      renderQuantitySyncFunctionality();
    }, 100);
  });
});